// Personal timezone preferences are separate from the shared team schedule.
export const AUTOMATIC_TIMEZONE = 'automatic'

const commonTimezones: Record<string, string> = {
  UTC: 'UTC (Coordinated Universal Time)',
  'America/New_York': 'Eastern Time (US & Canada)',
  'America/Chicago': 'Central Time (US & Canada)',
  'America/Denver': 'Mountain Time (US & Canada)',
  'America/Los_Angeles': 'Pacific Time (US & Canada)',
  'America/Phoenix': 'Arizona',
  'America/Anchorage': 'Alaska',
  'Pacific/Honolulu': 'Hawaii',
  'Europe/London': 'London',
  'Europe/Paris': 'Paris',
  'Europe/Berlin': 'Berlin',
  'Europe/Rome': 'Rome',
  'Europe/Madrid': 'Madrid',
  'Europe/Amsterdam': 'Amsterdam',
  'Europe/Stockholm': 'Stockholm',
  'Asia/Tokyo': 'Tokyo',
  'Asia/Shanghai': 'Shanghai',
  'Asia/Seoul': 'Seoul',
  'Asia/Kolkata': 'Mumbai / Kolkata',
  'Asia/Dubai': 'Dubai',
  'Australia/Sydney': 'Sydney',
  'Australia/Melbourne': 'Melbourne',
  'Australia/Perth': 'Perth',
}

export function isValidTimezone(timezone: string): boolean {
  try {
    new Intl.DateTimeFormat('en', { timeZone: timezone }).format()
    return true
  } catch { return false }
}

export function getDeviceTimezone(): string {
  try {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
    return timezone && isValidTimezone(timezone) ? timezone : 'UTC'
  } catch { return 'UTC' }
}

export function getTimezoneOptions(...extraZones: (string | null)[]) {
  let zones = Object.keys(commonTimezones)
  const supportedValuesOf = (Intl as typeof Intl & { supportedValuesOf?: (key: string) => string[] }).supportedValuesOf
  if (supportedValuesOf) {
    try { zones = supportedValuesOf('timeZone') } catch { /* Keep common zones for older browsers. */ }
  }
  // Preserve saved/device aliases even when the browser list uses a different
  // canonical spelling. Keep legacy saved values visible until explicitly changed.
  return [...new Set(['UTC', ...zones, ...extraZones.filter((zone): zone is string => !!zone)])]
    .sort()
    .map(value => ({ value, label: commonTimezones[value] ? `${commonTimezones[value]}${value === 'UTC' ? '' : ` (${value})`}` : value.replace(/_/g, ' ') }))
}
